export default __webpack_public_path__ + "static/media/gem-logo.36bbf250.png";